import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import BatchDetail from '@/views/BatchDetail.vue'
import LoginView from '@/views/Login.vue'
import { isLoggedIn } from '@/auth'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
        { path: '/', name: 'dashboard', component: Dashboard },
        { path: '/batches/:code', name: 'batchDetail', component: BatchDetail, props: true }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.public) {
        next()
        return
    }
    if (isLoggedIn()) {
        next()
        return
    }
    next({ path: '/login', query: { redirect: to.fullPath } })
})

export default router
